import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Account Redux states
import { CANCEL_TASK } from './actionTypes';
import { cancelTaskSuccessful, cancelTaskFailed } from './actions';

// Include call API
import { getTasksAPI } from '../../../api/tasks';

const tasksAPI = getTasksAPI();

function* cancelTask({ payload: { task, response, token, history } }) {
  try {
    const response2 = yield call(tasksAPI.cancelTask, task.taskCode, response, token);

    // ➔ VALIDACIÓN DE RESPUESTA: Si la API o RCS devuelve un estado de error
    if (response2 && (response2.status >= 400 || response2.code === 'ERR' || response2.error)) {
      const serverError = response2.error || response2.message || 'Error al cancelar la tarea';
      throw new Error(serverError);
    }

    yield put(cancelTaskSuccessful(response2.message));
  } catch (error) {
    console.error('Error in cancelTaskSaga:', error);

    // ➔ Extracción limpia del texto del error
    const errorMessage =
      typeof error === 'string' ? error : error.error || error.message || 'Error al cancelar la tarea';

    yield put(cancelTaskFailed(errorMessage));
  }
}

export function* watchDeleteTask() {
  yield takeEvery(CANCEL_TASK, cancelTask);
}

function* cancelTaskSaga() {
  yield all([fork(watchDeleteTask)]);
}

export default cancelTaskSaga;
